import React from "react";

import {OutlineAlert} from "../components/ExtAlerts";

// Used by every screen when the server returns 1028 without a message.
export const SERVER_ERROR_FALLBACK =
  'Two-factor authentication is not unavailable. Please contact us for help.';

// 1028 (HTTP 500): the server cannot read this account's stored MFA secret.
// Never user-caused and not retryable, so this replaces the interactive
// controls on the screen rather than sitting above them - there is nothing
// useful for the user to submit. Renders the server's message plus the same
// support contact the challenge screen uses.
const ExtMfaServerError = (props) => (
  <React.Fragment>
    <OutlineAlert color="danger" dismissable={false}>
      {props.message}
    </OutlineAlert>
    <p className="text-center mt-3">
      <span className="text-muted">
        Having problems? Contact <a target="_blank" rel="noopener noreferrer" href="//www.cabfare.com.au/contact-us">CabFare</a> for assistance.
      </span>
    </p>
  </React.Fragment>
);

export default ExtMfaServerError;
